// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "caller_number",
                Decco.stringToJson(v.caller_number)
              ],
              [
                "msisdn",
                Decco.stringToJson(v.msisdn)
              ],
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "location",
                Decco.stringToJson(v.location)
              ],
              [
                "order_stage",
                Decco.stringToJson(v.order_stage)
              ],
              [
                "raised_by",
                Decco.stringToJson(v.raised_by)
              ],
              [
                "issue",
                Decco.listToJson(Decco.stringToJson, v.issue)
              ],
              [
                "ticket_action",
                Decco.listToJson(Decco.stringToJson, v.ticket_action)
              ],
              [
                "issue_comments",
                Decco.stringToJson(v.issue_comments)
              ],
              [
                "action_comments",
                Decco.stringToJson(v.action_comments)
              ],
              [
                "start_ts",
                Decco.stringToJson(v.start_ts)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
